import { createStore } from "vuex";
import { auth } from "./auth.module";
import { studio } from "./studio.module";

const store = createStore({
  modules: {
    auth,
    studio,
  },
});

export default store;
